import script from "./VpnModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VpnModal.vue?vue&type=script&setup=true&lang=js"

import "./VpnModal.vue?vue&type=style&index=0&id=6e142162&scoped=true&lang=css"
import "./VpnModal.vue?vue&type=style&index=1&id=6e142162&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e142162"]])

export default __exports__